import { render, staticRenderFns } from "./FieldsConfig.vue?vue&type=template&id=61d7568e"
import script from "./FieldsConfig.vue?vue&type=script&lang=js"
export * from "./FieldsConfig.vue?vue&type=script&lang=js"
import style0 from "./FieldsConfig.vue?vue&type=style&index=0&id=61d7568e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports